
import axios from '@/utils/request'
var Qs = require('qs')

export default {
	deliverTypes: ['take', 'carry', 'express',],
	// 'agent', 'signDeliver'
	// // // 2020-10-31
	// // pendingReceivesSearch(params) {
	// //   return axios.get('/weddingDressHall/deliveries/pending-receives?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	// // },
	// 2021-11-12
	search(params) {
		return axios.get('/weddingDressHall/delivery?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	},

	// // 2020-11-21
	// pickSearch(params) {
	// 	return axios.get('/weddingDressHall/deliveries/pick-search?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	// },
	// // 2020-11-13
	// findByBatchSerialNo(params) {
	// 	return axios.get('/weddingDressHall/deliveries/find-by-batch-serial-no', params)
	// },
	// // 2020-11-16
	// exsitBySerialNos(params) {
	// 	return axios.post('/weddingDressHall/deliveries/exsit-by-serial-nos', params)
	// },

	// // 2020-11-22
	// batchPrint(params) {
	// 	return axios.put('/weddingDressHall/deliveries/batch-print', params);
	// },
	// // 2020-11-22
	// batchPrintEOrders(params) {
	// 	return axios.put('/weddingDressHall/deliveries/batch-print-EOrders', params);
	// },
	// // 2020-11-22
	// exportExcel(params) {
	// 	return axios.get('/weddingDressHall/deliveries/export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	// },

	// // 2020-11-22
	// exportExcelAddress(params) {
	// 	return axios.get('/weddingDressHall/deliveries/export-excel-address?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	// },

	// // 2020-08-12
	// dhlOrderExportExcel(params) {
	// 	return axios.get('/weddingDressHall/deliveries/dhl-order-export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	// },
	// // 2020-08-12
	// dhlBillExportExcel(params) {
	// 	return axios.get('/weddingDressHall/deliveries/dhl-bill-export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	// },
	// // 2020-11-22
	// batchVirtualDelivery(params) {
	// 	return axios.put('/weddingDressHall/deliveries/batch-virtual-delivery', params);
	// },
	// // 2020-11-23
	// batchUploadTracking(ids) {
	// 	return axios.post('/weddingDressHall/deliveries/batch-upload-tracking', ids)
	// },

	// // 2020-11-23
	// updateRemark(params) {
	// 	return axios.put('/weddingDressHall/deliveries/update-remark', params);
	// },
	// // 2020-11-23
	// batchUpdateRemark(params) {
	// 	return axios.put('/weddingDressHall/deliveries/batch-update-remark', params);
	// },
	// // 2020-11-23
	// updateDeliverInfo(id, params) {
	// 	return axios.put('/weddingDressHall/deliveries/' + id + '/update-deliver-info', params)
	// },
	// // 2020-11-23
	// updateAttachment(id, params) {
	// 	return axios.put('/weddingDressHall/deliveries/' + id + '/update-attachment', params);
	// },
	// // 2020-11-23
	// settle(id, params) {
	// 	return axios.put('/weddingDressHall/deliveries/' + id + '/settle', params);
	// },
	// // 2020-11-23
	// findBySerialNoOrTracking(params) {
	// 	return axios.get('/weddingDressHall/deliveries/find-by-serial-no-or-tracking', params);
	// },
	// // 2020-11-23
	// findBySerialNo(params) {
	// 	return axios.get('/weddingDressHall/deliveries/find-by-serial-no', params);
	// },
	// // 2020-11-23
	// findByTracking(params) {
	// 	return axios.get('/weddingDressHall/deliveries/find-by-tracking', params);
	// },
	// // 2020-11-23
	// cricleDeliver(params) {
	// 	return axios.put('/weddingDressHall/deliveries/circle-deliver', params);
	// },
	// // 2020-11-28
	// pendingPickCount() {
	// 	return axios.get('/weddingDressHall/deliveries/pending-pick-count');
	// },
	// // 2020-12-09
	// unSettle(params) {
	// 	return axios.get('/weddingDressHall/deliveries/un-settle', params);
	// },
	// // 2020-12-09 账单
	// updateCourierCost(id, params) {
	// 	return axios.put('/weddingDressHall/deliveries/' + id + '/update-courier-cost', params);
	// },
	// // 2020-12-09 账单
	// removeDeliverySettlementById(id) {
	// 	return axios.put('/weddingDressHall/deliveries/' + id + '/remove-delivery-settlement-by-id');
	// },
	// // 2020-10-16
	// findByOrderUuid(orderUuid) {
	// 	return axios.get('/weddingDressHall/deliveries/find-by-order-uuid/' + orderUuid);
	// },
	// // 2020-12-20
	// check(id) {
	// 	return axios.put('/weddingDressHall/deliveries/' + id + '/check');
	// },
	// // 2021-02-16
	// vagueFindBySerialNo(params) {
	// 	return axios.get('/weddingDressHall/deliveries/vague-find-by-serial-no', params);
	// },
	// // 2021-02-16
	// vagueFindByTracking(params) {
	// 	return axios.get('/weddingDressHall/deliveries/vague-find-by-tracking', params);
	// },


	// // 2021-02-18
	// retrieve(id) {
	// 	return axios.put('/weddingDressHall/deliveries/' + id + '/retrieve');
	// },
	// // 2021-02-18
	// change(id, params) {
	// 	return axios.put('/weddingDressHall/deliveries/' + id + '/change', params);
	// },
	// // 2021-02-18
	// updateCustomerInfo(id, params) {
	// 	return axios.put('/weddingDressHall/deliveries/' + id + '/update-customer-info', params)
	// },
	// // 2021-02-18
	// reDeliver(params) {
	// 	return axios.put('/weddingDressHall/deliveries/re-deliver', params);
	// },
	// // 2021-06-24
	// countWorkbench() {
	// 	return axios.get('/weddingDressHall/deliveries/count-workbench');
	// },

	// // 2021-07-12
	// calcRate(params) {
	// 	return axios.put('/weddingDressHall/deliveries/calc-rate', params);
	// },
	// // 2021-07-15
	// updateFlags(params) {
	// 	return axios.put('/weddingDressHall/deliveries/update-flags', params)
	// },
	// // 2021-08-27
	// sellerShip(id, params) {
	// 	return axios.put('/weddingDressHall/deliveries/' + id + '/seller-ship', params)
	// },
	// // 2021-08-31
	// refreshTracking(params) {
	// 	return axios.put('/weddingDressHall/deliveries/refresh-tracking', params)
	// },
	// // 2021-07-07
	// // countWorkbench(destCountryCode) {
	// //   return axios.post('/weddingDressHall/deliveries/upload-lianbang-etd/' + destCountryCode);
	// // },
	// // 2021-02-18
	// findById(id) {
	// 	return axios.get('/weddingDressHall/deliveries/' + id);
	// },

}

